import "./ZeroSearchResult.scss";

import { SearchResultState } from "shared/src/types/articlesearch/SearchResult";
import React, { FunctionComponent } from "react";
import { Col, Row, Well } from "react-bootstrap";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import Suggestion from "../../shared/article-badges/Suggestion";
import MetroMarketsSuggestions from "./MetroMarketsSuggestions";
import OrSearchSuggestions from "./OrSearchSuggestions";
import { RecentlyViewedSuggestions } from "./RecentlyViewedSuggestions";

type ZeroSearchResultProps = {
    searchResult: SearchResultState | undefined | null;
    fullPageBanner?: React.ReactNode | null;
    filterPanelShowButton?: React.ReactNode | null;
};

export const ZeroSearchResult: FunctionComponent<ZeroSearchResultProps> = ({
    searchResult,
    fullPageBanner,
    filterPanelShowButton
}: ZeroSearchResultProps) => {
    const originalQuery = searchResult?.q;
    const results = searchResult?.result;

    return (
        <Row className="zero-result">
            <Col lg={12}>
                <Well className="ex-search-query-badge">
                    <div className="ex-search-header">
                        <Row>
                            <Col lg={12}>
                                <h2>
                                    <FormattedMessage id="SD_NO_RESULT_HEADLINE" values={{ query: originalQuery }} />
                                </h2>
                                <FormattedHTMLMessage id="SD_NO_RESULT_DESCRIPTION" tagName="ul" />
                                {filterPanelShowButton}
                                {results && (
                                    <Suggestion
                                        query={{
                                            original: originalQuery || "",
                                            final: results.query,
                                            suggestion: results.suggestion
                                        }}
                                        amount={{
                                            final: results.amount,
                                            suggestion: results.suggestionHits
                                        }}
                                    />
                                )}
                            </Col>
                        </Row>
                    </div>
                </Well>
                {fullPageBanner}
                <OrSearchSuggestions results={searchResult?.result} />
                <MetroMarketsSuggestions query={searchResult?.q} />
                <RecentlyViewedSuggestions query={searchResult?.q} />
            </Col>
        </Row>
    );
};
